import './App.css';
import {MainHeader} from './Components/Header';
import { MainFooter } from './Components/Footer';
import {Home} from './Components/Home';
import { Route, Routes } from 'react-router-dom';
import { NavBar } from './Components/NavBar';
import AboutUs  from './Components/About';
import FormMember from './Components/FormMember';
import './Components/i18';
import Constitution from './Components/Constitution';
import { HouseholdMember } from './Components/HouseholdMember';

function App() {
  return (
    <div className="appMainDiv">
      <MainHeader/>
      <NavBar/>
      <div className='routes'>
        <Routes >
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<AboutUs/>}/>
        <Route path='/constitution' element={<Constitution/>}/>
        <Route path='/formMember' element={<FormMember/>}/>
        <Route path='/Member' element={<HouseholdMember/>}/>
      </Routes>
      <MainFooter/>
      </div>
      
    </div>
  );
}
export default App;
